/**
 * The date the port 25 clause (vServer § 6 Absatz 5) names: a first vServer
 * ordered on or after it starts the three-month block. The FAQ and the order
 * step quote the same date. The backend's VSERVER_SMTP_BLOCK_FROM must not be
 * earlier than 00:00 Europe/Berlin on it.
 */
export const VSERVER_SMTP_BLOCK_DATE = {
  de: '26.10.2026',
  en: '26 October 2026'
} as const
